export default function Cancel() {
  return (
    <svg width="10" height="9" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.91797 2.12134L7.16061 6.36398" stroke="#828282" strokeLinecap="round" />
      <path d="M7.16016 2.12134L2.91752 6.36398" stroke="#828282" strokeLinecap="round" />
    </svg>
  )
}
